import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/shadcn/select'
import { cn } from '@/lib/utils'

export function SelectComponent({
  id,
  options,
  value,
  onChange,
  placeholder,
  className,
  disabled = false,
}: {
  id?: string
  options: string[] | { label: string; value: string }[]
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
  disabled?: boolean
}) {
  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger id={id} className={cn('w-[180px] px-1.5', className)}>
        <SelectValue className="truncate" placeholder={placeholder ?? 'Select'} />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => {
          if (typeof option === 'string') {
            return (
              <SelectItem key={option} value={option}>
                {option}
              </SelectItem>
            )
          }
          return (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          )
        })}
      </SelectContent>
    </Select>
  )
}
